module.exports = __webpack_public_path__ + "img/bguc-360-room-2-hires.5f5ebd76.jpg";